// High-risk country code values are checked by both the schema validation and by the form logic to show further fields.
// The high-risk country codes list needs to be set in this central util once received so that both can make the check.

const potentialHighRiskCitizenshipCodes: string[] = ['4']; // International Student applying to study in Australia only

let highRiskCountryCodes: string[] = [];

export function setHighRiskCountryCodes(codes: string[] | undefined) {
  highRiskCountryCodes = codes || [];
}

export function isCountryHighRisk(citizenship?: string, country?: string): boolean | undefined {
  const isPotentialHighRiskCitizenship = citizenship ? potentialHighRiskCitizenshipCodes.includes(citizenship) : false;
  return isPotentialHighRiskCitizenship && (country ? highRiskCountryCodes.includes(country) : false);
}